var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.numbersArray.length > 1)?_c('div',{attrs:{"data-test-id":"pagination-searchPagination"}},[_c('Pagination',{attrs:{"current-page":_vm.currentPage,"results":_vm.getResults},on:{"onPaginationClick":_vm.changePagination}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }